import { withCompInfo } from '@wix/editor-elements-integrations'
import { getFontValue } from '../../core/mappers/ScaledFont/ScaledFont.mapper'
import { TextInputCssCarmiData, TextInputDefinition } from '@wix/thunderbolt-components-native'
import { getMobileScaledFont } from '@wix/thunderbolt-becky-root'

export const css = withCompInfo<TextInputCssCarmiData, TextInputDefinition>()(
	// @ts-ignore - remove once siteFonts is added to CompInfo
	['compProps', 'isMobileView', 'styleProperties', 'compLayout', 'compDesign', 'siteFonts'],
	// @ts-ignore - remove once siteFonts is added to CompInfo
	({ compProps, isMobileView, styleProperties, compLayout, siteFonts }) => {
		const scale = compLayout.scale!
		return {
			'--fntlbl': getFontValue({
				themeFontMap: siteFonts,
				fontParam: styleProperties.fntlbl,
				isMobileView,
				callback: (fontValue: string) =>
					getMobileScaledFont(fontValue, scale, 16, compProps.labelMobileFontSize),
			}),
			'--fnt': getFontValue({
				themeFontMap: siteFonts,
				fontParam: styleProperties.fnt,
				isMobileView,
				callback: (fontValue: string) =>
					getMobileScaledFont(fontValue, scale, 13, compProps.inputMobileFontSize),
			}),
		}
	}
)
